/**
 * Troca obrigatória da senha temporária.
 *
 * Trocar a senha encerra as sessões abertas — inclusive esta. Por isso o fluxo
 * termina em novo login, e não numa navegação para dentro do sistema.
 */

import { useState } from "react";
import { Logo } from "../ds";
import { useNavigate } from "react-router-dom";

import CampoSenha from "../components/CampoSenha";

import { ApiError, apiFetch } from "../api/client";
import { useAuth } from "../auth/AuthContext";

const TAMANHO_MINIMO = 10;

export default function ChangePasswordPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const [atual, setAtual] = useState("");
  const [nova, setNova] = useState("");
  const [confirmacao, setConfirmacao] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function enviar(evento: React.FormEvent) {
    evento.preventDefault();
    setErro(null);

    if (nova !== confirmacao) {
      setErro("A confirmação não confere com a nova senha.");
      return;
    }
    if (nova.length < TAMANHO_MINIMO) {
      setErro(`A nova senha precisa ter pelo menos ${TAMANHO_MINIMO} caracteres.`);
      return;
    }

    setEnviando(true);
    try {
      await apiFetch<void>("/auth/password/change", {
        method: "POST",
        body: { current_password: atual, new_password: nova },
      });
      // O servidor revogou todas as sessões; entrar de novo é o caminho honesto.
      await logout();
      navigate("/entrar", { replace: true, state: { senhaTrocada: true } });
    } catch (falha) {
      setErro(
        falha instanceof ApiError ? falha.message : "Não foi possível alterar a senha.",
      );
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="shell">
      <div className="brand">
        <Logo tamanho={32} />
        <b>Aletia</b>
        <span>Armaturen · Valve Passport</span>
      </div>

      <form className="card card-estreito" onSubmit={enviar}>
        <h1>Defina uma nova senha</h1>
        <p className="sub">
          {user?.must_change_password
            ? "Sua senha atual é temporária e precisa ser trocada antes do primeiro uso."
            : "Escolha uma nova senha para a sua conta."}
        </p>

        <CampoSenha rotulo="Senha atual" valor={atual} onChange={setAtual} autoFocus />

        <CampoSenha
          rotulo="Nova senha"
          valor={nova}
          onChange={setNova}
          autoComplete="new-password"
          minLength={TAMANHO_MINIMO}
          ajuda={`Pelo menos ${TAMANHO_MINIMO} caracteres.`}
        />

        <CampoSenha
          rotulo="Confirme a nova senha"
          valor={confirmacao}
          onChange={setConfirmacao}
          autoComplete="new-password"
          minLength={TAMANHO_MINIMO}
        />

        {erro && (
          <p className="alerta" role="alert">
            {erro}
          </p>
        )}

        <button type="submit" className="btn btn-primario" disabled={enviando}>
          {enviando ? "Salvando…" : "Salvar e entrar novamente"}
        </button>
      </form>
    </div>
  );
}
